export default __webpack_public_path__ + "static/media/birke-1.cfe77b31.png";